import { combineReducers } from 'redux'
import getEntity from './get-entity'
import migrateEntity from './migrate-entity'

const reducer = combineReducers({
  getEntity,
  migrateEntity
})

export default reducer
